module.exports = __webpack_public_path__ + "img/apex to apex.82923d19.png";